// Tiny shared bits for the OTA admin panel: the labelled form field, the input
// styling token, and a couple of display formatters. Kept in one small module so
// the status / history / controls components stay focused on layout.
import type { ReactNode } from 'react';

export const inputClass =
  'w-full rounded-xl border border-black/10 bg-wash px-3 py-2.5 text-[14px] text-ink outline-none transition-colors focus:border-accent/60';

export function Field({
  label,
  hint,
  children
}: {
  label: string;
  hint?: string;
  children: ReactNode;
}) {
  return (
    <label className="block">
      <span className="text-[12px] font-semibold text-ink2">{label}</span>
      {hint && <span className="mt-0.5 block text-[11px] text-ink3">{hint}</span>}
      <div className="mt-1.5">{children}</div>
    </label>
  );
}

/** Human-readable byte size, e.g. `1.8 MB`. */
export function formatBytes(bytes: number | null | undefined): string {
  if (!bytes || bytes <= 0) return '—';
  const units = ['B', 'KB', 'MB', 'GB'];
  let n = bytes;
  let i = 0;
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i += 1;
  }
  return `${n >= 10 || i === 0 ? Math.round(n) : n.toFixed(1)} ${units[i]}`;
}

/** First 10 hex chars of a checksum for a compact, recognisable display. */
export function shortHash(hash: string | null | undefined): string {
  if (!hash) return '—';
  return hash.length > 12 ? `${hash.slice(0, 10)}…` : hash;
}
